import { createReducer, on } from '@ngrx/store';
import { Project } from '../../models/dbmodels';
import { EventLogViewModel, ProjectSearchRequest } from '../../models/viewmodels';
import { ItemConfigurationInputRequest, ItemConfigurationInputResponse } from 'src/app/models/pricing-view-models';
import { clearItemConfigurationInputRequest, clearItemConfigurationInputResponse, getItemConfigurationInputResponseFailure, getItemConfigurationInputResponseSuccess, updateItemConfigurationInputRequest } from './item-configuration-input.actions';


export interface ItemConfigurationInputRequestState {
    itemConfigurationInputRequest: ItemConfigurationInputRequest;
}
export const intitalItemConfigurationInputRequestState: ItemConfigurationInputRequestState = {
    itemConfigurationInputRequest: {} as ItemConfigurationInputRequest
}
export interface ItemConfigurationInputResponseState {
  itemConfigurationInputResponse: ItemConfigurationInputResponse;
  itemConfigurationInputRequest: ItemConfigurationInputRequest;
}

export const initialItemConfigurationInputResponseState: ItemConfigurationInputResponseState = {
  itemConfigurationInputRequest: {} as ItemConfigurationInputRequest,
  itemConfigurationInputResponse: {} as ItemConfigurationInputResponse
};

//export const pricingInputsFeatureKey = 'pricingInputsState';
export const itemConfigurationInputRequestFeatureKey = 'itemConfigurationInputRequestState';
export const itemConfigurationInputResponseFeatureKey = 'itemConfigurationInputResponseState';

export const itemConfigurationInputRequestReducer = createReducer(
    intitalItemConfigurationInputRequestState,
    on(updateItemConfigurationInputRequest, (state, { itemConfigurationInputRequest }): ItemConfigurationInputRequestState => {
        //console.log('updateItemConfigurationInputRequest', itemConfigurationInputRequest);
        let rtn = {
            ...state,
            itemConfigurationInputRequest
        };
        return rtn; 
    }),
    on(clearItemConfigurationInputRequest, (state): ItemConfigurationInputRequestState => {
        return intitalItemConfigurationInputRequestState;
    })

);
export const itemConfigurationInputResponseReducer = createReducer(
  initialItemConfigurationInputResponseState,
  on(getItemConfigurationInputResponseSuccess, (state, { itemConfigurationInputRequest, itemConfigurationInputResponse }): ItemConfigurationInputResponseState => {

    let rtn = {
      ...state,
      itemConfigurationInputRequest,
      itemConfigurationInputResponse
    };
    //console.log('getItemConfigurationInputResponseSuccess', rtn);
    return rtn;
  }),
  on(getItemConfigurationInputResponseFailure, (state, { error }): ItemConfigurationInputResponseState => {
    //console.error(error);
    return state;
  }),
  on(clearItemConfigurationInputResponse, (state): ItemConfigurationInputResponseState => {
    return initialItemConfigurationInputResponseState;
  })
);